import React from 'react'
import Navbar from '../components/navbar/navbar'
import Footer from '../components/footer/footer'
import { Table } from 'react-bootstrap'
import copy from '../assets/icons/icons8-copy-96.png'

function Homedubu() {
  return (
    <>
    <Navbar />
    <div className='margintt'>     
      <div className='center'><lebel>copy the link</lebel><input placeholder='the share link' type='text' /> <span className='copy' ><img width={"22px"} src={copy} />COPY</span></div>
      <h3 id='roboto' className='center margint'>View Saved Contacts</h3>
      <Table striped bordered hover>
      <thead>
        <tr>
          <th>SN</th>
          <th>FullName</th>
          <th>Phone</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>...</td>
          <td>...</td>
          
        </tr>
        <tr>
          <td>2</td>
          <td>...</td>
          <td>...</td>
          
        </tr>
        <tr>
          <td>Total</td>
          <td>...</td>
         
         
        </tr>
      </tbody>
    </Table>
    <h5 >Total = 28 Contacts</h5>
    <div><button className='get-started-btn' >Download VcardFile</button></div>

    </div>
    <Footer />
    </>
  )
}

export default Homedubu
